import { useEffect, useState } from "react";
import logo from "../../imagens/logonavbar2_plain.svg";
import styles from "./MenuFilter.module.css";

function MenuFilter({ handles, filterControl }) {
  const categories = [
    "Apicultura",
    "Culturas Anuais",
    "Equideocultura",
    "Frango de Corte",
    "Fruticultura",
    "Gado de Corte",
    "Gado de Leite",
    "Galinhas Poedeiras",
    "Olericultura",
    "Outras Criações",
    "Piscicultura",
    "Suinocultura",
  ];

  const subCategorias = {
    Fruticultura: [
      "Todas",
      "Laranja",
      "Limão",
      "Acerola",
      "Goiaba",
      "Manga",
      "Maracujá",
      "Pêssego",
      "Uva",
      "Jabuticaba",
    ],
    "Culturas Anuais": [
      "Todas",
      "Cana",
      "Feijão",
      "Mandioca",
      "Arroz",
      "Milho",
      "Café",
      "Eucalipto",
      "Capineira",
    ],
    Olericultura: [
      "Todas",
      "Batata Inglesa",
      "Batata Doce",
      "Batata Baroa",
      "Inhame",
      "Alface",
      "Couve",
      "Cenoura",
      "Tomate",
      "Cebolinha",
      "Cebola",
      "Alho",
      "Pepino",
      "Beterraba",
      "Espinafre",
      "Salsa",
      "Repolho",
      "Couve Flor",
      "Almeirão",
      "Pimentão",
      "Quiabo",
      "Jiló",
    ],
  };

  const dropdownOptions = ["Número de inscrição", "Nome do proprietário"];
  const natureOptions = ["01 - Comercial", "02 - Subsistência"];

  const [selectedCategory, setSelectedCategory] = useState("Apicultura");
  const [selectedNatureza, setSelectedNatureza] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [searchInput, setSearchInput] = useState("");

  const {handleCategory, handleSubCategory, handleNatureza} = handles;
  const {selectedOption, onSelectChange, onSearchChange} = filterControl;

  useEffect(() => {
    handleCategory(selectedCategory);
    handleNatureza(selectedNatureza);
    handleSubCategory(selectedSubCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounce: notificar pai com onSearchChange
  useEffect(() => {
    const delay = setTimeout(() => {
      if (onSearchChange) {
        onSearchChange(searchInput); // 👈 envia o texto final para o pai
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchInput, onSearchChange]);

  const clearSearch = () => {
    setSearchInput("");
    if (onSearchChange) onSearchChange(""); // notifica o pai também no clear
  };

  return (
    <div className={styles.sidebar}>
      {/* Logo */}
      <div className={styles.sidebarHeader}>
        <img src={logo} alt="Logo" className={styles.logo} />
      </div>

      {/* Filtro por tipo de busca */}
      <div className={styles.searchBar}>
        <select
          className={styles.dropdown}
          value={selectedOption}
          onChange={(e) => onSelectChange(e.target.value)}
        >
          {dropdownOptions.map((opt, idx) => (
            <option key={idx} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      {/* Campo de pesquisa */}
      <div className={styles.searchBar}>
        <input
          type="text"
          placeholder="Pesquisar"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        <button className={styles.searchButton} onClick={clearSearch}>
          X
        </button>
      </div>

      <div className={styles.divRadioButtons}>
        {/* Categorias */}
        <div className={styles.categorySection}>
          <h4>CATEGORIA</h4>
          <ul>
            {categories.map((cat) => (
              <li key={cat}>
                <input
                  type="radio"
                  name="category"
                  value={cat}
                  checked={selectedCategory === cat}
                  onChange={() => {
                    setSelectedCategory(cat);
                    handleCategory(cat);
                    setSelectedSubCategory(null);
                    handleSubCategory(null);
                  }}
                />{" "}
                {cat}
              </li>
            ))}
          </ul>
        </div>

        {Object.hasOwn(subCategorias, selectedCategory) && (
          <div className={styles.categorySection}>
            <h4>SUBCATEGORIA</h4>
            <ul>
              {subCategorias[selectedCategory].map((subcat) => (
                <li key={subcat}>
                  <input
                    type="radio"
                    name="subCategory"
                    value={subcat}
                    onChange={() => {
                      setSelectedSubCategory(subcat);
                      handleSubCategory(subcat);
                    }}
                  />{" "}
                  {subcat}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Natureza */}
        <div className={styles.categorySection}>
          <h4>NATUREZA</h4>
          <ul>
            <li>
              <input
                type="radio"
                name="nature"
                value=""
                checked={selectedNatureza === null}
                onChange={() => {
                  setSelectedNatureza(null);
                  handleNatureza(null);
                }}
              />{" "}
              Todas
            </li>
            {natureOptions.map((natureza) => (
              <li key={natureza}>
                <input
                  type="radio"
                  name="nature"
                  value={natureza}
                  checked={selectedNatureza === natureza}
                  onChange={() => {
                    setSelectedNatureza(natureza);
                    handleNatureza(natureza);
                  }}
                />{" "}
                {natureza}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default MenuFilter;
